import React, { memo } from 'react'

import { Box, FlexBox, Text, TextButton } from '@surglogs-app/ui'
import { DefaultModal } from '@surglogs-app/ui.modal'

import { FileType } from '../constants'
import { useTranslation } from '../services/translation/useTranslation'

// TODO: create config package to use here
export const CONTACT_EMAIL = 'info@surglogs.com'

interface SupportedFilesProps {
  hideModal: () => void
  fileTypes: FileType[]
}

export const SupportedFilesModal = memo(
  ({ hideModal, fileTypes }: SupportedFilesProps) => {
    const { t } = useTranslation()

    return (
      <DefaultModal {...{ title: t('supportedFiles'), hideModal }}>
        <Box>
          <FlexBox {...{ flex: '1', ai: 'center', mb: 'sm' }}>
            <FlexBox {...{ flex: 1, fd: 'column', gap: 'sm' }}>
              <Text {...{ bold: true }}>{t('fileType')}</Text>
              {fileTypes.map(({ name }) => (
                <Text key={name} {...{ bold: true }}>
                  {name}
                </Text>
              ))}
            </FlexBox>
            <FlexBox {...{ fd: 'column', flex: 1, gap: 'sm' }}>
              <Text {...{ bold: true }}>{t('fileExtension')}</Text>
              {fileTypes.map(({ extensions }) => (
                <Text key={extensions}>{extensions}</Text>
              ))}
            </FlexBox>
          </FlexBox>

          <Text>
            {t('contactText')}{' '}
            <TextButton
              {...{
                href: `mailto:${CONTACT_EMAIL}`,
                as: 'a',
                target: '_blank',
              }}>
              {t('contactLink')}
            </TextButton>
            .
          </Text>
        </Box>
      </DefaultModal>
    )
  },
)
